import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from './Layout';

const Leads = () => {
  const [filter, setFilter] = useState('All');
  
  const leads = [
    { id: 1, name: 'Rahul Sharma', phone: '9876543210', email: 'rahul@email.com', requirement: '3kW System', status: 'New', assigned: 'Unassigned' },
    { id: 2, name: 'Priya Patel', phone: '9876543211', email: 'priya@email.com', requirement: '5kW System', status: 'In Progress', assigned: 'Rahul (Sales)' },
    { id: 3, name: 'Amit Kumar', phone: '9876543212', email: 'amit@email.com', requirement: '2kW System', status: 'Converted', assigned: 'Suresh (Sales)' },
    { id: 4, name: 'Neha Singh', phone: '9876543213', email: 'neha@email.com', requirement: '10kW System', status: 'New', assigned: 'Unassigned' },
    { id: 5, name: 'Vikram Reddy', phone: '9876543214', email: 'vikram@email.com', requirement: '7kW System', status: 'In Progress', assigned: 'Rahul (Sales)' },
  ];

  const filteredLeads = filter === 'All' ? leads : leads.filter(l => l.status === filter);

  return (
    <Layout>
      <div className="mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white">Leads Management</h1>
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Manage and track all customer inquiries</p>
        </div>
        <button className="px-5 py-2.5 bg-[#10B981] hover:bg-emerald-600 text-white font-bold rounded-xl shadow-lg shadow-emerald-500/20 transition-all text-sm">
          + Add Lead
        </button>
      </div>

      <div className="flex gap-2 mb-6 flex-wrap">
        {['All', 'New', 'In Progress', 'Converted'].map((status) => (
          <button
            key={status}
            onClick={() => setFilter(status)}
            className={`px-4 py-2 rounded-xl text-xs font-bold transition-all ${
              filter === status
                ? 'bg-slate-900 text-white dark:bg-emerald-500 dark:text-white shadow-sm'
                : 'bg-white text-slate-600 hover:bg-slate-100 dark:bg-slate-800/80 dark:text-slate-300 dark:hover:bg-slate-700/80 border border-slate-200 dark:border-slate-700/60'
            }`}
          >
            {status}
          </button>
        ))}
      </div>

      <div className="bg-white dark:bg-slate-900/50 rounded-2xl shadow-sm dark:shadow-2xl border border-slate-200 dark:border-slate-800 overflow-hidden transition-colors">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-slate-100/70 dark:bg-slate-950/80 text-slate-600 dark:text-slate-400 border-b border-slate-200 dark:border-slate-800">
              <tr>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Name</th>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Contact</th>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Requirement</th>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Status</th>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Assigned To</th>
                <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-800/60">
              {filteredLeads.map((lead) => (
                <tr key={lead.id} className="hover:bg-slate-50 dark:hover:bg-slate-900/30 transition-colors">
                  <td className="px-6 py-4 text-sm font-bold text-slate-900 dark:text-white">{lead.name}</td>
                  <td className="px-6 py-4 text-sm text-slate-600 dark:text-slate-300">
                    <div>{lead.phone}</div>
                    <div className="text-xs text-slate-400 dark:text-slate-500">{lead.email}</div>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600 dark:text-slate-300 font-medium">{lead.requirement}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-widest rounded-full ${
                      lead.status === 'New' ? 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20' :
                      lead.status === 'In Progress' ? 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400 border border-yellow-500/20' :
                      'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20'
                    }`}>
                      {lead.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600 dark:text-slate-400 font-medium">{lead.assigned}</td>
                  <td className="px-6 py-4">
                    <Link
                      to={`/admin/leads/${lead.id}`}
                      className="text-[#10B981] hover:text-emerald-600 dark:hover:text-emerald-400 text-xs font-extrabold transition-colors"
                    >
                      View Details →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default Leads;